import {GlobalVariables} from "../GlobalVariables";
import {gsap} from "../LibrariesImport";

export default class HeaderNavs {
	constructor() {
		this.header = document.querySelector(".header-main");

		if (this.header) {
			this.overlay = this.header.querySelector(".overlay");
			this.navBg = this.header.querySelector(".nav-main-bg");

			this.toggleMobileNav();
			this.initMegaMenu();

			document.addEventListener("escape.pressed", () => {
				this.closeAllLev2();
			});

			GlobalVariables.resizeCallbacks.push(this);
		}
	}

	toggleMobileNav() {
		const openTrigger = this.header.querySelector(".nav-toggle");
		if (openTrigger) {
			openTrigger.addEventListener("click", () => {
				if (document.body.classList.contains("navs-open")) {
					this.closeMobileNav();
				} else {
					this.openMobileNav();
				}
			});
		}
	}

	openMobileNav() {
		document.body.classList.add("navs-open");

		GlobalVariables.lenis?.stop();
	}

	closeMobileNav() {
		document.body.classList.remove("navs-open");

		const activeMenuItems = this.header.querySelectorAll(".menu-item-lev1.active");
		activeMenuItems.forEach(item => {
			item.classList.remove("active");
			const subnav = item.querySelector(".lev2");
			if (subnav) {
				subnav.classList.remove("show");
			}
		});

		GlobalVariables.lenis?.start();
	}

	initMegaMenu() {
		// Un clic sur l'overlay ferme tout
		this.overlay.addEventListener("click", () => {
			this.closeAllLev2();
		});

		this.navMain = this.header.querySelector(".nav-main");
		this.levelOneItems = this.navMain.querySelectorAll(".menu-item-lev1.menu-item-has-children");

		this.levelOneItems.forEach(levelOne => {
			levelOne.toggle = levelOne.querySelector("button[data-header='toggler']");
			levelOne.levelTwo = levelOne.querySelector(".lev2-items");

			if (!levelOne.levelTwo) {
				return;
			}

			levelOne.toggle.addEventListener("click", (e) => {
				e.preventDefault();

				if (levelOne.classList.contains("active")) {
					this.header.classList.remove("subnav-active");
					this.adjustNavBgHeight(levelOne.levelTwo);
					levelOne.classList.remove("active");
					levelOne.levelTwo.classList.remove("show");
					levelOne.toggle.setAttribute("aria-expanded", false);

					if (window.innerWidth > GlobalVariables.header.getBreakpoint()) {
						GlobalVariables.lenis?.start();
					}
				} else {
					this.closeAllLev2();

					this.header.classList.add("subnav-active");
					this.adjustNavBgHeight(levelOne.levelTwo);
					levelOne.classList.add("active");
					levelOne.levelTwo.classList.add("show");
					levelOne.toggle.setAttribute("aria-expanded", true);

					if (window.innerWidth > GlobalVariables.header.getBreakpoint()) {
						GlobalVariables.lenis?.stop();
					}
				}
			});
		});
	}

	closeAllLev2() {
		this.header.classList.remove("subnav-active");
		this.levelOneItems.forEach(item => {
			item.classList.remove("active");
			item.levelTwo.classList.remove("show");
			item.querySelector("button[data-header='toggler']").setAttribute("aria-expanded", "false");
		});

		if (window.innerWidth > GlobalVariables.header.getBreakpoint()) {
			GlobalVariables.lenis?.start();
		}
	}

	restoreNav() {
		this.closeAllLev2();
		this.closeMobileNav();
	}

	adjustNavBgHeight(levelTwo) {
		if (this.navBg && window.innerWidth > GlobalVariables.header.getBreakpoint()) {
			gsap.to(this.navBg, {duration: 0.3, height: levelTwo.offsetHeight});
		}
	}

	resize() {
		this.restoreNav();
	}
}
